import React, { useState, useRef, useEffect } from "react";
import GoogleCSE from "./GoogleCSE";
import "./GoogleCSE.css";

const CSE = () => {
  const [isInputVisible, setIsInputVisible] = useState(false);
  const inputRef = useRef(null);

  const handleClickOutside = (event) => {
    if (inputRef.current && !inputRef.current.contains(event.target)) {
      setIsInputVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div>
      {!isInputVisible && (
        <button
          className="cicSearch-button"
          onClick={() => setIsInputVisible(true)}
          aria-label="search"
        >
          <i className="fas fa-search" style={{ fontSize: "20px" }}></i>
        </button>
      )}
      {isInputVisible && (
        <div className="cicSearch-input" ref={inputRef}>
          <GoogleCSE />
        </div>
      )}
    </div>
  );
};

export default CSE;
